import React from "react";
import { connect } from "react-redux";
import { getArticles, removeArticle } from "../../actions/business";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  UncontrolledAlert,
  Button
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/business/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";

class BusinessPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: []
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { position } = urlParams;
    const activeCategoryType = this.getCurrentCategory(position);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType
        ? activeCategoryType.display_name
        : null
    });
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(position) {
    var matchRoles = this.props.business.categories.filter(value => {
      return value.id == position || value.name == position;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0];
    }
    return activeCategoryType;
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    this.props.removeArticle(row.id);
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType
        ? activeCategoryType.display_name
        : null
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      position: activeCategoryType ? activeCategoryType.name : null
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      errorMsg,
      successBackMsg
    } = this.props.business;

    const heads = ["投放區域", "標題", "聯繫人", "電話", "郵箱", "操作"];
    const dataAttributes = ["title", "contact", "phone", "email"];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                {/* <DropdownSelection
                  Types={categories}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                /> */}
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
                <Button
                  className="btn btn-default"
                  tag={Link}
                  to={"/dash/admin/business-advertisements/new"}
                >
                  添加廣告
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    business: state.business,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    removeArticle: params => dispatch(removeArticle(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessPage);
